(function ($, generic) {
  Drupal.behaviors.productOfferV1 = {
    attach: function (context) {
      var self = this;

      if (this.attached) {
        return;
      }

      $('.js-product-offer__edd--pc-trigger', context).once().click(function (e) {
        e.preventDefault();
        var hash = this.hash;
        var $content = $('.js-delivery-date-form', context);
        var popupWidth = self.isMobile() ? '100%' : '480px';

        if ($content.length > 0) {
          generic.overlay.launch({
            cssClass: 'product__edd--pc__cboxContent',
            inline: true,
            href: hash,
            override_mobile_width_height: 1,
            includeBackground: true,
            includeCloseLink: true,
            initialHeight: 0,
            height: 0,
            width: popupWidth
          });
        }
      });

      $('.js-shipping-modal', context).once().click(function (e) {
        e.preventDefault();
        var $activeElement = $(document.activeElement);
        var content = $('.site-bag__overlay-content', 'body');

        if (content.length > 0) {
          generic.overlay.launch({
            content: content.clone(true),
            includeBackground: true,
            includeCloseLink: true,
            initialHeight: 0,
            height: 0,
            width: '50%',
            onComplete: function () {
              $(window).trigger('macproMakeVisible');
              $(this).colorbox.resize();
            },
            onClosed: function () {
              $activeElement.focus();
            }
          });
        }
      });
    },
    isMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

      return currentBpWidth <= bPlargeUp;
    },
    attached: false
  };
})(jQuery, window.generic || {});
